import VideoRenderer from '../videos/videoRenderer';
import React from 'react';

function Answer({ article }) {
  return (
    <div id="tukur-answer" className="centered-784">
      {article.landingpage.answerVideo && (
        <div className="video-answer text-center">
          {VideoRenderer.renderVideoImage(
            article.landingpage.answerVideo,
            article.landingpage.answerVideo.preview,
            article.landingpage.answerVideo.description
          )}
          {article.landingpage.answerVideo.description && (
            <div>
              <p />
              <p className="text-left">{article.landingpage.answerVideo.description}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

Answer.propTypes = {
  article: React.PropTypes.object
};

export default Answer;



// WEBPACK FOOTER //
// ./components/landingpage/answer.js